import type { BreakpointsOptions } from '@mui/system';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    '3xs': true;
    '2xs': true;
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
  }
}

declare module '@mui/system' {
  interface BreakpointOverrides {
    '3xs': true;
    '2xs': true;
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
  }
}

export const breakpoints: BreakpointsOptions = {
  values: {
    '3xs': 321,
    '2xs': 360,
    xs: 480,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
};
